/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all, delay } from "redux-saga/effects"
import {
  CREATE_EVENT_RECORD,
  DELETE_EVENT_RECORD,
  UPDATE_EVENT_RECORD,
  LOAD_RECORD_EVENT_DETAILS,
  LOAD_RECORDS_META_DATA,
  LOAD_EVENT_DATE_RECORDS,
  LOAD_OFFER_LIST,
  CREATE_OFFER_LIST,
  ADD_VENUE_LIST,
  UPDATE_VENUE_LIST,
  LOAD_VENUE_LIST,
  LOAD_CITY_VENUE,
  LOAD_VENUE_LOCATION_LIST,
  ADD_VENUE_LOCATION_LIST,
  UPDATE_VENUE_LOCATION_LIST,
} from "./constants"

import {
  loadEventDateRecordsError,
  loadEventDateRecords as loadEventDateRecordsAction,
  loadRecordEventDetails as loadRecordEventDetailsAction,
  loadRecordEventDetailsSuccess,
  loadRecordEventDetailsError,
  createEventRecordError,
  createEventRecordSuccess,
  deleteEventRecordError,
  deleteEventRecordSuccess,
  updateEventRecordError,
  updateEventRecordSuccess,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadEventDateRecordsSuccess,
  loadOfferList,
  loadOfferListSuccess,
  loadOfferListError,
  createOfferRecordSuccess,
  createOfferRecordError,
  loadVenueList,
  loadVenueListSuccess,
  loadVenueListError,
  loadCityVenueList,
  loadCityVenueListSuccess,
  loadCityVenueListError,
  addVenueListSuccess,
  addVenueListError,
  updateVenueListSuccess,
  updateVenueListError,
  loadVenueLocations,
  loadVenueLocationsSuccess,
  loadVenueLocationsError,
  addVenueLocationsSuccess,
  addVenueLocationsError,
  updateVenueLocationsSuccess,
  updateVenueLocationsError,
} from "./actions"

import {
  loadRecordEventDetails,
  loadRecordsMetaData,
  createEventRecord,
  deleteEventRecord,
  updateEventRecord,
  loadEventDateRecords,
  loadOfferDetails,
  createOfferDetails,
  loadVenueDetails,
  loadVenueNameDetails,
  addVenueDetails,
  updateVenueDetails,
  loadVenueLocationDetails,
  addVenueLocationDetails,
  updateVenueLocationDetails,
} from "./remotes"

function* loadRecordEventDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_RECORD_EVENT_DETAILS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadRecordEventDetailsAction(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadRecordEventDetails, id)

        if (result) {
          yield put(loadRecordEventDetailsSuccess(result.data))
        } else {
          yield put(loadRecordEventDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadRecordEventDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadEventDateRecordsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EVENT_DATE_RECORDS),
    })
    const { explicitLoad } = load
    const { event_date } = explicitLoad || {}
    yield put(loadEventDateRecordsAction(event_date)) // Calling Dropdown API's

    // alert("2")

    if (explicitLoad) {
      try {
        console.log("e date saga entervvvvvv%%%%%%%%%%%%%%%%", event_date)

        const result = yield call(loadEventDateRecords, event_date)
        console.log(result, "result from offer saga")

        if (result) {
          yield put(loadEventDateRecordsSuccess(result.data))
        } else {
          yield put(loadEventDateRecordsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEventDateRecordsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
function* createEventRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_EVENT_RECORD),
    })
    const { eventUpdate } = create || {}

    if (create) {
      try {
        yield call(createEventRecord, eventUpdate)
        // yield delay(1000)

        var successVal = createEventRecordSuccess(
          eventUpdate,
          "Event Details Created Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          createEventRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* editEventRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_EVENT_RECORD),
    })

    console.log("FFFF &&& Lokesh Func ->", edit)

    const { eventUpdate } = edit || {}

    if (edit) {
      try {
        yield call(updateEventRecord, eventUpdate)
        // yield delay(1000)
        yield put(
          updateEventRecordSuccess(eventUpdate, "Record Updated Successfully")
        )
        console.log(eventUpdate._id, "saga event id")
      } catch (error) {
        yield put(
          updateEventRecordError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* deleteEventRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_EVENT_RECORD),
    })
    const { eventRemoveId } = del || {}
    if (del) {
      // yield call(setSubmitting, true)

      try {
        yield call(deleteEventRecord, eventRemoveId)
        yield delay(1000)
        console.log(eventRemoveId, "saga for delete event")

        yield put(
          deleteEventRecordSuccess(
            eventRemoveId,
            "Event Details Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          deleteEventRecordError(
            (error && error.response && error.response.message) || ""
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Offer list saga
function* loadOfferListSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_OFFER_LIST),
    })
    const { explicitLoad } = load
    const { offer_list } = explicitLoad || {}
    yield put(loadOfferList(offer_list)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        console.log("e date from offer list", offer_list)

        const result = yield call(loadOfferDetails, offer_list)
        console.log(result, "result from offer saga")
        if (result) {
          yield put(loadOfferListSuccess(result.data))
        } else {
          yield put(loadOfferListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadOfferListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Venue Locations
function* loadVenueLocationSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_VENUE_LOCATION_LIST),
    })
    const { explicitLoad } = load
    const { id } = explicitLoad || {}
    yield put(loadVenueLocations(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        console.log("city venue", id)

        const result = yield call(loadVenueLocationDetails, id)
        if (result) {
          yield put(loadVenueLocationsSuccess(result.data))
        } else {
          yield put(loadVenueLocationsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadVenueLocationsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addVenueLocationsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_VENUE_LOCATION_LIST),
    })
    const { locationData } = create || {}

    if (create) {
      try {
        yield call(addVenueLocationDetails, locationData)
        // yield delay(1000)

        var successVal = addVenueLocationsSuccess(
          locationData,
          "Venue Locations Added Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          addVenueLocationsError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* updateVenueLocationsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_VENUE_LOCATION_LIST),
    })
    const { locationData } = create || {}

    if (create) {
      try {
        yield call(updateVenueLocationDetails, locationData)
        // yield delay(1000)

        var successVal = updateVenueLocationsSuccess(
          locationData,
          "Venue Locations Updated Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          updateVenueLocationsError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Offer list saga
function* loadVenueDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_VENUE_LIST),
    })
    const { explicitLoad } = load
    const { id } = explicitLoad || {}
    yield put(loadVenueList(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        console.log("venue", id)

        const result = yield call(loadVenueDetails, id)
        if (result) {
          yield put(loadVenueListSuccess(result.data))
        } else {
          yield put(loadVenueListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadVenueListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//Offer list saga
function* loadCityDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CITY_VENUE),
    })
    const { explicitLoad } = load
    const { id } = explicitLoad || {}
    yield put(loadCityVenueList(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        console.log("city venue", id)

        const result = yield call(loadVenueNameDetails, id)
        if (result) {
          yield put(loadCityVenueListSuccess(result.data))
        } else {
          yield put(loadCityVenueListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadCityVenueListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addVenueDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_VENUE_LIST),
    })
    const { venueData } = create || {}

    if (create) {
      try {
        yield call(addVenueDetails, venueData)
        // yield delay(1000)

        var successVal = addVenueListSuccess(
          venueData,
          "Venue Record Added Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          addVenueListError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* updateVenueDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_VENUE_LIST),
    })
    const { venueData } = create || {}

    if (create) {
      try {
        yield call(updateVenueDetails, venueData)
        // yield delay(1000)

        var successVal = updateVenueListSuccess(
          venueData,
          "Venue Record Updated Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          updateVenueListError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
function* createOfferSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_OFFER_LIST),
    })
    const { offerList } = create || {}

    if (create) {
      try {
        yield call(createOfferDetails, offerList)
        // yield delay(1000)

        var successVal = createOfferRecordSuccess(
          offerList,
          "Offer Created Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          createOfferRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      // const clientProfile = yield call(
      //   loadRecordsMetaData,
      //   "client_profile",
      //   "post"
      // )
      const eventType = yield call(loadRecordsMetaData, "event_type", "post")
      const event = yield call(loadRecordsMetaData, "event", "post")
      const branch = yield call(loadRecordsMetaData, "branch", "post")

      // const city = yield call(loadRecordsMetaData, "city", "post")
      // const offer = yield call(loadRecordsMetaData, "offer", "post")

      //Deliverables dropdowns
      // const eventDate = yield call(loadRecordsMetaData, "lead_event_date")
      let recordsMetaData = {
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
        eventTypeOptions:
          (eventType &&
            eventType.data &&
            eventType.data.length > 0 &&
            eventType.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.eventType,
                    value: c._id,
                    shortCode: c.shortCode,
                    //  companyId: c.companyId
                  }
                )
              )) ||
          [],
        eventOptions:
          (event &&
            event.data &&
            event.data.length > 0 &&
            event.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.eventName,
                    value: c._id,
                    eventCode: c.eventCode,
                    //  companyId: c.companyId
                  }
                )
              )) ||
          [],
        // offers:
        //   (offer &&
        //     offer.data &&
        //     offer.data.length > 0 &&
        //     offer.data
        //       .filter((_) => _.status === 1)
        //       .map((c) =>
        //         Object.assign(
        //           {},
        //           {
        //             label: c.offerTitle,
        //             value: c._id,
        //             offerImage: c.offerImage,
        //             fromDate: c.fromDate,
        //             toDate: c.toDate,
        //             //  companyId: c.companyId
        //           }
        //         )
        //       )) ||
        //   [],
        // cityOptions:
        //   (city &&
        //     city.data &&
        //     city.data.length > 0 &&
        //     city.data
        //       .filter((_) => _.status === 1)
        //       .map((c) =>
        //         Object.assign(
        //           {},
        //           {
        //             label: c.name,
        //             value: c._id,
        //             sourceId: c.sourceId,
        //             stateId: c.state && c.state._id,
        //           }
        //         )
        //       )) ||
        //   [],
        // clientProfileOptions:
        //   (clientProfile &&
        //     clientProfile.data &&
        //     clientProfile.data.length > 0 &&
        //     clientProfile.data
        //       .filter((_) => _.status === 1)
        //       .map((c) =>
        //         Object.assign({}, { label: c.clientProfile, value: c._id })
        //       )) ||
        //   [],
      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadEventDateRecordsSaga(),
    createEventRecordSaga(),
    editEventRecordSaga(),
    deleteEventRecordSaga(),
    loadRecordEventDetailsSaga(),
    loadRecordsMetaDataSaga(),
    loadOfferListSaga(),
    createOfferSaga(),
    loadVenueDetailsSaga(),
    loadCityDetailsSaga(),
    addVenueDetailsSaga(),
    updateVenueDetailsSaga(),
    loadVenueLocationSaga(),
    addVenueLocationsSaga(),
    updateVenueLocationsSaga(),
  ])
}
